import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginPoojari } from '../../services/poojariService';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import PasswordField from '../../components/PasswordField';

const RED = '#B22222';
const DARK_RED = '#8B0000';
const GOLD = '#FFD700';

const PoojariLogin = () => {
    const [formData, setFormData] = useState({
        email: '',
        phoneNumber: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [loginType, setLoginType] = useState('email');

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const cleanEmail = () =>
        formData.email.trim().toLowerCase();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loginType === 'email' && !cleanEmail()) {
            return toast.warning('Enter your email');
        }
        if (loginType === 'phone'
                && !/^[6-9]\d{9}$/.test(
                    formData.phoneNumber)) {
            return toast.warning(
                'Enter a valid 10 digit mobile number');
        }
        if (!formData.password) {
            return toast.warning('Enter your password');
        }

        setLoading(true);
        try {
            const loginData = {
                password: formData.password,
                ...(loginType === 'email'
                    ? { email: cleanEmail() }
                    : { phoneNumber:
                        formData.phoneNumber.trim() })
            };

            // Poora object aata hai - tokens aur poojari info
            const data = await loginPoojari(loginData);

            const poojariData = {
                id: data.poojariId,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                phoneNumber: data.phoneNumber,
                status: data.status,
                city: data.city,
                pincode: data.pincode,
                role: 'POOJARI'
            };

            login(poojariData, data.token,
                data.refreshToken);

            toast.success('Login successful!');

            setTimeout(() => {
                navigate('/poojari-dashboard');
            }, 300);

        } catch (error) {
            const msg = error.response?.data?.message || '';

            if (msg.includes('not approved')) {
                toast.info(
                    'Your profile is under review. Our team '
                    + 'will call you at your chosen slot. '
                    + 'You can login once approved.',
                    { autoClose: 6000 });
            } else if (msg.includes('verify your email')) {
                toast.warning(
                    'Please verify your email first');
            } else if (msg.includes('deactivated')) {
                toast.error(
                    'Your account is deactivated. '
                    + 'Please contact support.');
            } else {
                toast.error(msg || 'Login failed');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ backgroundColor: '#FFF5F5' }}
            className="pb-screen">

            {/* ===== HEADER ===== */}
            <div style={{
                backgroundColor: DARK_RED,
                padding: '14px 16px'
            }}>
                <div className="d-flex align-items-center gap-2">
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: GOLD,
                            fontSize: '22px',
                            lineHeight: 1,
                            padding: 0
                        }}>
                        ←
                    </button>
                    <div>
                        <p className="mb-0 fw-bold"
                            style={{
                                color: GOLD,
                                fontSize: '15px'
                            }}>
                            🙏 Poojari Login
                        </p>
                        <p className="mb-0"
                            style={{
                                color: '#FFE4B5',
                                fontSize: '12px'
                            }}>
                            Access your booking dashboard
                        </p>
                    </div>
                </div>
            </div>

            <div className="container"
                style={{ maxWidth: '480px' }}>
                <div className="py-4">

                    {/* Email / Phone toggle */}
                    <div className="d-flex gap-1 p-1 mb-4"
                        style={{
                            backgroundColor: 'white',
                            border: `1px solid ${GOLD}`,
                            borderRadius: '12px'
                        }}>
                        <button
                            type="button"
                            className="flex-fill border-0 fw-bold"
                            style={{
                                padding: '10px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                backgroundColor:
                                    loginType === 'email'
                                    ? RED : 'transparent',
                                color: loginType === 'email'
                                    ? GOLD : '#666'
                            }}
                            onClick={() =>
                                setLoginType('email')}>
                            Email
                        </button>
                        <button
                            type="button"
                            className="flex-fill border-0 fw-bold"
                            style={{
                                padding: '10px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                backgroundColor:
                                    loginType === 'phone'
                                    ? RED : 'transparent',
                                color: loginType === 'phone'
                                    ? GOLD : '#666'
                            }}
                            onClick={() =>
                                setLoginType('phone')}>
                            Phone
                        </button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        {loginType === 'email' ? (
                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    Email address
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    placeholder="you@example.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                    autoComplete="email"
                                    autoCapitalize="none"
                                    spellCheck="false"
                                    style={{ borderColor: GOLD }}
                                />
                            </div>
                        ) : (
                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    Mobile number
                                </label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    name="phoneNumber"
                                    placeholder="10 digit number"
                                    value={formData.phoneNumber}
                                    maxLength="10"
                                    inputMode="numeric"
                                    onChange={e =>
                                        setFormData({
                                            ...formData,
                                            phoneNumber:
                                                e.target.value
                                                    .replace(
                                                        /\D/g, '')
                                        })}
                                    style={{ borderColor: GOLD }}
                                />
                            </div>
                        )}

                        <div className="mb-4">
                            <PasswordField
                                label="Password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Your password"
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn w-100 fw-bold py-2"
                            style={{
                                backgroundColor: RED,
                                color: GOLD,
                                border: 'none',
                                borderRadius: '10px'
                            }}
                            disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                                                {/* Password bhool gaye - reset ka rasta */}
                        <div className="text-center mt-3">
                            <Link to="/forgot-password/poojari"
                                style={{
                                    color: RED,
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    textDecoration: 'none'
                                }}>
                                Forgot password?
                            </Link>
                        </div>
                    </form>

                    <div className="p-3 mt-4"
                        style={{
                            backgroundColor: '#FFF8F0',
                            borderRadius: '10px'
                        }}>
                        <small className="text-muted">
                            New poojaris can login only after
                            our team verifies the profile over
                            a call.
                        </small>
                    </div>

                    <div className="text-center mt-4">
                        <small className="text-muted">
                            Not registered yet?{' '}
                            <Link to="/poojari-register"
                                style={{
                                    color: RED,
                                    fontWeight: 600
                                }}>
                                Register here
                            </Link>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PoojariLogin;